<template>
  <b-skeleton animation="wave" class="footer-wrapper" />
</template>

<script>
export default {
  name: "FooterSkeletonBox"
};
</script>
